var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDatabricks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0444 9.8936L12.0108 15.4893L1.26675 9.51063L0.75 9.78722V14.1277L12.0108 20.3829L22.0444 14.8085V17.1064L12.0108 22.7021L1.26675 16.7234L0.75 17V17.7446L12.0108 24L23.25 17.7446V13.4043L22.7333 13.1276L12.0108 19.0851L1.95574 13.5107V11.2128L12.0108 16.7872L23.25 10.5319V6.25531L22.6903 5.93616L12.0108 11.8723L2.47249 6.59574L12.0108 1.29787L19.8482 5.65957L20.5372 5.27659V4.74467L12.0108 0L0.75 6.25531V6.93616L12.0108 13.1914L22.0444 7.59574V9.8936Z",
    fill: "#EE3D2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDatabricks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/databricks.e558d590a5970971412bf3c42564121d.svg";